import { RestClient } from '../../../api/restClient';
import { GetTemplatesResult } from '../types/template';

export class TemplateService {
  private restClient: RestClient;

  constructor(restClient: RestClient) {
    this.restClient = restClient;
  }

  async getGuidedDoingTemplates(): Promise<GetTemplatesResult> {
    const url = '/Template/GetGuidedDoingTemplates';
    return await this.restClient.get<GetTemplatesResult>(url);
  }
}
